import { Injectable, computed, signal } from '@angular/core';

import { AuthState } from '../models/auth-state.model';
import { AuthSession } from '../models/auth-session.model';

const initialAuthState: AuthState = {
  session: null,
  isAuthenticated: false,
  isLoading: false,
  isInitialized: false,
  error: null
};

@Injectable({
  providedIn: 'root'
})
export class AuthStateStore {
  private readonly state = signal<AuthState>(initialAuthState);

  readonly snapshot = this.state.asReadonly();
  readonly session = computed(() => this.state().session);
  readonly isAuthenticated = computed(() => this.state().isAuthenticated);
  readonly isLoading = computed(() => this.state().isLoading);
  readonly isInitialized = computed(() => this.state().isInitialized);
  readonly error = computed(() => this.state().error);

  setLoading(isLoading: boolean): void {
    this.patchState({ isLoading });
  }

  setSession(session: AuthSession | null): void {
    this.patchState({
      session,
      isAuthenticated: Boolean(session),
      isInitialized: true,
      error: null,
      isLoading: false
    });
  }

  clearSession(): void {
    this.patchState({
      session: null,
      isAuthenticated: false,
      isInitialized: true,
      error: null,
      isLoading: false
    });
  }

  setError(error: string | null): void {
    this.patchState({ error, isLoading: false });
  }

  setInitialized(isInitialized: boolean): void {
    this.patchState({ isInitialized });
  }

  reset(): void {
    this.state.set(initialAuthState);
  }

  private patchState(patch: Partial<AuthState>): void {
    this.state.update((currentState) => ({
      ...currentState,
      ...patch
    }));
  }
}
